import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../setupStore';

const initialState = {
  value: null,
  loading: false,
};

export const ResultReplanNotificationStateSlice = createSlice({
  name: 'result',
  initialState,
  reducers: {
    resultReplan: (state, action: PayloadAction<any>) => {
      state.value = action.payload;
    },
    jobsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { resultReplan, jobsLoading } =
  ResultReplanNotificationStateSlice.actions;

export const selectResultReplan = (state: RootState) =>
  state.resultReplanNotification?.value;
export const selectJobsLoading = (state: RootState) =>
  state.resultReplanNotification?.loading;

export default ResultReplanNotificationStateSlice.reducer;
